import DataModelDesigner from './DataModelDesigner';
import { entities, mockData } from '../../mock/data-model/Asset360';

export default function Asset360Page() {
  return <DataModelDesigner title="Asset 360" entities={entities} mockData={mockData} />;
}
